import firebase from '@/firebase/firebase'

const fb = firebase.firestore()

export function copyFromCollection (fromCompanyId, collection) {
    return new Promise(async resolve => {
        let ref = await fb.collection(`/company/${fromCompanyId}/${collection}/`).get()
        resolve( ref.docs.map(doc => {
                return { id : doc.id, data : doc.data() }
            })
        )
    })
}

export function pasteToCollection (toCompanyId, collection, obj) {
    return new Promise(async (resolve, reject) => {
        let batch = fb.batch()
        try {
            obj.forEach(doc => {
                let ref = fb.collection(`/company/${toCompanyId}/${collection}/`).doc(doc.id)
                batch.set(ref, doc.data)
            })
            await batch.commit()
            resolve('')
        } catch (err) {
            reject(err.message)
        }
    })
}